import { useCallback, useState } from "react";

import client from "../client";
import handleApiError from "../../hooks/handleApiError";

export default function useInitializeSubscription() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const request = useCallback(async (payload) => {
    try {
      setLoading(true);
      const response = await client.post(
        "/plans/initialize-subscription",
        payload
      );

      setData(response.data?.data);
      setLoading(false);

      window.open(response.data?.data?.authorization_url, "_blank");
      return true;
    } catch (error) {
      setLoading(false);
      handleApiError(error);
    }
  }, []);

  return { request, loading, data };
}
